import { render, staticRenderFns } from "./IrReturnedPackageTrackBarcode.vue?vue&type=template&id=ee537420&"
import script from "./IrReturnedPackageTrackBarcode.vue?vue&type=script&lang=js&"
export * from "./IrReturnedPackageTrackBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports